export default {
  "checkinRecord.title": "Checkin Records",
  "checkinRecord.column.no": "#NO",
  "checkinRecord.column.userId": "UserID",
  "checkinRecord.column.email": "Email",
  "checkinRecord.column.name": "Name",
  "checkinRecord.column.firstName": "Firs tName",
  "checkinRecord.column.lastName": "Last Name",
  "checkinRecord.column.totalCheckinCount": "Total Checkin Count",
  "checkinRecord.column.monthlyCheckinCount": "Monthly Checkin Count",
  "checkinRecord.column.sevenDayStreak": "7-Day Streak",
  "checkinRecord.column.currentStreak": "Current Streak",
  "checkinRecord.column.todayCheckinStatus": "Today's Checkin Status",
  "checkinRecord.column.rewardType": "Reward Type",
  "checkinRecord.column.rewardAmount": "Reward Amount",
  "checkinRecord.column.lastCheckinTime": "Last Checkin Time",
  "checkinRecord.status.notCheckedIn": "Not Checked In",
  "checkinRecord.status.checkedIn": "Checked In",
  "checkinRecord.search.userId": "UserID",
  "checkinRecord.search.email": "Email",
  "checkinRecord.tooltip.copy.userId": "Copy UserID: {text}",
  "checkinRecord.copy.success": "Copied to clipboard",
};
